import { FaLock } from "react-icons/fa";

interface DisabledPanelWrapperProps {
  isDisabled: boolean;
  children: React.ReactNode;
  message?: string;
}

export function DisabledPanelWrapper({ isDisabled, children }: DisabledPanelWrapperProps) {
  return (
    <div className="h-full">
      <div className={isDisabled ? "opacity-10 pointer-events-none" : ""}>{children}</div>

      {/* Overlay message when disabled - rendered via portal with fixed positioning */}
      {isDisabled && (
        <div className="absolute inset-0  flex items-center justify-center p-4 pointer-events-none">
          <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border-2 border-slate-200 p-6 max-w-[280px] transform transition-all duration-300 animate-in fade-in zoom-in-95">
            <div className="flex flex-col items-center text-center space-y-3">
              <div className="w-14 h-14 text-gray-600 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center shadow-inner">
                <FaLock size={24} />
              </div>
              <h4 className="text-base font-bold text-slate-800 mb-2">Edit Mode Required</h4>
              <p className="text-sm text-slate-600 leading-relaxed">
                Switch to Edit Mode to add or modify elements
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
